import { ITenant } from './tenants';

export enum WidgetType {
	Bar = 'Bar',
	Line = 'Line'
}

export enum WidgetAxis {
	Y = 'Y',
	X = 'X'
}

export enum AnalyticsTimePeriod {
	Week = 'week',
	Month = 'month',
	SixMonths = '6months'
}

export enum AnalyticsKeys {
	ActiveUsers = 'activeUsers',
	NewUsers = 'newUsers',
	deviceTypeGraph = 'deviceTypeGraph',
	activeUsersGraph = 'activeUsersGraph',
	newUsersGraph = 'newUsersGraph',
	errors = 'errors'
}

export enum AnalyticsSupportedDevices {
	Desktop = 'Desktop',
	Mobile = 'Mobile',
	Tablet = 'Tablet',
	Bot = 'Bot',
	Unknown = 'Unknown'
}

export interface IAnalyticsContext {
	tenants: ITenant[];
	setTenants: (tenants: ITenant[]) => void;
	timePeriod: `${AnalyticsTimePeriod}`;
	setTimePeriod: (timePeriod: `${AnalyticsTimePeriod}`) => void;
	xDomain: number[];
	setXDomain: (xDomain: number[]) => void;
}

export interface IAnalyticsProps {
	data: any;
}

export interface IAnalytic {
	cnt?: number;
	action?: string;
	created: number;
	device?: string;
	method?: string;
	geo?: string;
	tenant?: string;
	projectId?: string;
}

export interface IAnalyticData {
	analytics: IAnalytic[];
}

export interface IWidgetItem {
	count: number;
	name: string;
	date: number;
}
export interface IWidgetProps {
	items: IWidgetItem[];
}

export interface IWidgetAccessors {
	xAccessor: (d: Partial<IWidgetItem>) => number;
	yAccessor: (d: Partial<IWidgetItem>) => number;
}

export interface IWidgetXYTickComponentProps {
	value: any;
}
